import React from 'react';

import { AppProcessingProvider } from './ApplicationProcessingProvider';
import { Application } from '~/data/useApplication';
import { SchoolCustomizations } from '~/data/useSchoolCustomizations';
import { ApplicationCardsStateProvider } from './ApplicationCardsStateProvider';
import { ApplicationAdditionalDocumentRequestContextProvider } from './AdditionalDocumentRequestProvider';

export type { CardSection } from './ApplicationCardsStateProvider';
export type { Process } from './ApplicationProcessingProvider';
export { useAppProcessing } from './ApplicationProcessingProvider';
export { useAdditionalDocumentRequest } from './AdditionalDocumentRequestProvider';
export { useApplicationCards, useApplicationCard } from './ApplicationCardsStateProvider';

type ApplicationDetailContextProps = {
  application: Application;
  children: React.ReactNode;
  schoolCustomizations: SchoolCustomizations;
};
export const ApplicationDetailContext = (props: ApplicationDetailContextProps) => {
  return (
    <AppProcessingProvider application={props.application} schoolCustomizations={props.schoolCustomizations}>
      <ApplicationCardsStateProvider>
        <ApplicationAdditionalDocumentRequestContextProvider>
          {props.children}
        </ApplicationAdditionalDocumentRequestContextProvider>
      </ApplicationCardsStateProvider>
    </AppProcessingProvider>
  );
};
